import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import {
  clearBusinessPolicyRiskState,
  fetchBusinessPolicyRiskAsync,
  fetchBusinessPolicyRiskListAsync,
} from "../../../../../../redux/businessPolicy/buisenessPolicyRiskLocation/businessPolicyRiskLocationActions";

export const useBusinessPolicyRiskLocation = (
  customerPolicyId?: number,
  incrementalNumber?: number
) => {
  const dispatch = useDispatchWrapper();
  const { data: riskLocations, risklocation } = useSelector(
    (storeState: IStoreState) => storeState.business.riskLocation
  );

  const riskLocationsDropDown = React.useMemo(() => {
    return riskLocations.map((item) => ({
      label:
        item.location_number +
        ` (${item.address}, ${item.city}, ${item.province_or_state}, ${item.postal_code})`,
      value: String(item.location_number || ""),
    }));
  }, [riskLocations]);

  const refreshData = () => {
    if (customerPolicyId) {
      if (incrementalNumber !== undefined) {
        dispatch(
          fetchBusinessPolicyRiskAsync(
            Number(customerPolicyId),
            incrementalNumber
          )
        );
      } else {
        dispatch(fetchBusinessPolicyRiskListAsync(Number(customerPolicyId), "ACTIVE"));
      }
    }
  }

    React.useEffect(() => {
      if (customerPolicyId) {
        if (incrementalNumber !== undefined) {
          dispatch(
            fetchBusinessPolicyRiskAsync(
              Number(customerPolicyId),
              incrementalNumber
            )
          );
        } else {
          dispatch(fetchBusinessPolicyRiskListAsync(Number(customerPolicyId), "ACTIVE"));
        }
      }
      return () => {
        dispatch(clearBusinessPolicyRiskState());
      };
    }, [customerPolicyId, incrementalNumber]);

    return { riskLocationsDropDown, riskLocations, risklocation, refreshData };
  };

